import { notifications } from '@mantine/notifications'
import { IconAlertTriangle, IconCircleCheck, IconCircleX } from '@tabler/icons-react'
import classes from './notify.module.css'

const TONES = {
  success: { color: '#00922f', Icon: IconCircleCheck },
  warning: { color: '#f59f00', Icon: IconAlertTriangle },
  error: { color: '#f03e3e', Icon: IconCircleX },
}

/**
 * Figma "notif" (421:96686): 450×88 white card, radius 8, 28px outlined status icon, title
 * 14/600 #212529 over a 14/400 #868E96 message, 28px close box.
 */
export function notifyV2({ tone = 'success', title, message, autoClose = 8000, id }) {
  const { color, Icon } = TONES[tone] || TONES.success
  return notifications.show({
    id,
    title,
    message,
    autoClose,
    withBorder: false,
    icon: <Icon size={28} stroke={1.5} color={color} />,
    classNames: {
      root: classes.root,
      icon: classes.icon,
      body: classes.body,
      title: classes.title,
      description: classes.description,
      closeButton: classes.close,
    },
  })
}
